import { render } from "./LoyaltyProgramSection.vue?vue&type=template&id=1b1d50bd&scoped=true"
const script = {}

import "./LoyaltyProgramSection.vue?vue&type=style&index=0&id=1b1d50bd&scoped=true&lang=css"

import exportComponent from "/home/armin/w/euro-petrol-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b1d50bd"]])

export default __exports__